<div class="modal">
  <div class="modal__content">
    <div class="window" [style.padding]="'60px 10px'">
      <div class="title">{{'t.prizes' | translate}}</div>
      <i class="window__close icon-close" (click)="modal.close()"></i>

      @if (tournament?.GroupList?.CustomPrizeList) {
        <ng-container *ngTemplateOutlet="customPrizes"></ng-container>
      } @else {
        <!-- @if (prizesData$ | async; as data) {
          <div class="prizes">
            @if (data?.mappedPrizes) {
              @for (prize of data?.mappedPrizes; track prize) {
                <div class="prizes__place_alternative">
                  <div class="text-gradient">
                    {{prize?.place}} {{prize?.place_sufix}}
                  </div>
                  @if (prize?.money_award_cents) {
                    <div class="prizes__place--value">
                      {{ prize?.currency_symbol }} {{ prize?.money_award }}
                    </div>
                  }
                  @if (prize.freespins_count) {
                    <div class="prizes__place--value">
                      {{ prize?.freespins_count }} {{ 'labl.free-spin' | translate }}
                    </div>
                  }
                </div>
              }
            }
          </div>
        } -->
      }


      <ng-template #customPrizes>
        <div class="prizes">
          @for (prize of tournament?.GroupList?.CustomPrizeList | keyvalue: originalOrder | slice: 0: 50; track prize) {
            <div class="prizes__place_alternative">
              <div class="text-gradient">
                {{prize?.key}}
              </div>
              <div class="prizes__place--value">
                {{prize?.value}}
              </div>
            </div>
          }
        </div>
      </ng-template>

    </div>
  </div>
</div>
